const Locations = [{ label: "Online sastanak (Google Meets, Zoom Meeting)" }, { label: "Naša kompanija (Heliant d.o.o. Makenzijeva 24, Beograd)" }, { label: "Vaša ustanova" }];

export default Locations;
